<template>
    <div class="codics-aonaer-info-sys-list-body">
        <WebHeader></WebHeader>
        <BreadCrumb style="margin-top: 100px;" :bread-list="breadList"></BreadCrumb>
        <div class="codics-aonaer-info-sys-list-box">
            <div class="codics-aonaer-info-sys-list-container">
                <div class="codics-aonaer-info-sys-list-year-tab-box">
                    <div class="codics-aonaer-info-sys-list-year-tab-container">
                        <div class="codics-aonaer-info-sys-list-year-tab-item" v-for="(item, index) in yearList"
                            :key="index"
                            :style="{ color: index == yearIndex ? '#FFF' : '#222', background: index == yearIndex ? '#ea5b18' : '#F7F7F7' }"
                            @click="yearIndex = index; nowYear = item; jumpPage();">
                            {{ item }}年
                        </div>
                    </div>
                </div>
                <div class="codics-aonaer-info-sys-list-view">
                    <div class="codics-aonaer-info-sys-list-table-tab-item" v-for="(item, index) in tabData"
                        @click="nowMonth = index; nowMonth = nowMonth; jumpPage()"
                        :style="{ 'top': index * 50 + 'px', 'z-index': index == nowMonth ? '3' : 0, 'border-right': index == nowMonth ? 'unset' : '1px solid #EEE;', 'background': index == nowMonth ? '#ea5b18' : '#FFF', color: index == nowMonth ? '#FFF' : '#333' }"
                        :key="index" v-html="item"></div>
                    <div class="codics-aonaer-info-sys-list-table-box">
                        <el-table :data="tableData" stripe style="width: 100%">
                            <el-table-column prop="index" label="排名" width="180">
                                <template slot-scope="scope">
                                    {{ scope.$index + 1 }}
                                </template>
                            </el-table-column>
                            <el-table-column prop="nick" label="姓名" width="180">
                                <template slot-scope="scope">
                                    <el-image style="top:3.5px;height: 30px;width: 30px;"
                                        :src="scope.row.himg == null ? 'https://cdn.bosscaigou.com/huayuan/img/yasuo_60bc7e65a6d385d503656e12772d226.webp' : ('https://cdn.bosscaigou.com/' + scope.row.himg)"
                                        fit="fill">
                                    </el-image>
                                </template>
                            </el-table-column>
                            <el-table-column prop="nick" label="姓名" width="180">
                            </el-table-column>
                            <el-table-column prop="depart.name" label="部门">
                            </el-table-column>
                            <el-table-column prop="points" label="积分">
                            </el-table-column>
                            <el-table-column align="right" label="操作" min-width="150">
                                <template slot-scope="scope">
                                    <el-button size="mini" type="info" plain
                                        @click="jifenDialog = true; nowId = scope.row.id; jifenData = []; infoRecordFuc();">积分明细</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
            </div>
        </div>
        <WebFooter></WebFooter>
        <el-dialog title="积分明细" :visible.sync="jifenDialog">
            <el-table class="codics-aonaer-info-sys-list-mingxi-table" :data="jifenData" stripe show-summary
                style="width: 100%;left: 50%;transform: translateX(-50%);">
                <el-table-column prop="remark" label="积分备注" width="180">
                </el-table-column>
                <el-table-column prop="num" label="积分数值" width="180">
                </el-table-column>
                <el-table-column align="right" prop="ctime" label="积分时间" width="180">
                    <template slot-scope="scope">
                        {{ initTime(scope.row.ctime) }}
                    </template>
                </el-table-column>
            </el-table>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="jifenDialog = false">关闭</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import dayjs from 'dayjs';
import WebHeader from '@/components/WebHeader';
import WebFooter from '@/components/WebFooter';
import BreadCrumb from '@/components/BreadCrumb';
import { listBoard, infoRecord } from '@/api';
export default {
    data() {
        return {
            jifenDialog: false,
            tableData: [],
            tabData: ['创新总榜', '1月份', '2月份', '3月份', '4月份', '5月份', '6月份', '7月份', '8月份', '9月份', '10月份', '11月份', '12月份'],
            nowId: 0,
            breadList: [
                {
                    title: '网站首页',
                    url: '#'
                },
                {
                    title: '奥纳尔制冷',
                    url: '#'
                },
                {
                    title: '积分榜单',
                    url: '#'
                }
            ],
            yearIndex: 0,
            nowYear: 0,
            nowMonth: 0,
            yearList: [2025],
            jifenData: []
        }
    },
    mounted() {
        this.nowYear = this.$route.params.year;
        this.nowMonth = this.$route.params.month;
        this.listBoardFuc();
    },
    methods: {
        initTime(str) {
            return dayjs(str).format('YYYY-MM-DD HH:mm:ss');
        },
        async infoRecordFuc() {

            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            let data = await infoRecord({ year: this.nowYear, month: this.nowMonth, id: this.nowId });

            loading.close();

            if (data.code == 200) {

                this.jifenData = data.data;

            } else {

                this.$message.error(data.message);

            }

        },
        jumpPage() {
            // window.location = window.location.replace('list\/(\d+)\/');
            let s = window.location + '';
            s = s.replace(/list\/(\d+)\/(\d+)/, 'list/' + this.nowYear + '/' + this.nowMonth);
            window.location = s;

        },
        async listBoardFuc() {

            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            let data = await listBoard({ year: this.$route.params.year, month: this.$route.params.month });

            loading.close();

            if (data.code == 200) {

                this.tableData = data.data;

            } else {

                this.$message.error(data.message);

            }

        }
    },
    components: {
        WebHeader,
        WebFooter,
        BreadCrumb
    }
}
</script>

<style>
.codics-aonaer-info-sys-list-body {
    height: fit-content;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
}

.codics-aonaer-info-sys-list-box {
    height: fit-content;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    margin-bottom: 70px;
}

.codics-aonaer-info-sys-list-container {
    height: fit-content;
    width: 100%;
    max-width: 1360px;
    position: relative;
    float: left;
    left: 50%;
    transform: translateX(-50%);
    box-sizing: border-box;
}

.codics-aonaer-info-sys-list-year-tab-box {
    height: 120px;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    padding: 40px 0;
}

.codics-aonaer-info-sys-list-year-tab-container {
    height: 100%;
    width: 100%;
    max-width: 1360px;
    position: relative;
    float: left;
    left: 50%;
    transform: translateX(-50%);
    box-sizing: border-box;
    padding: 0 5px;
}

.codics-aonaer-info-sys-list-year-tab-item {
    height: 100%;
    width: fit-content;
    position: relative;
    float: left;
    line-height: 40px;
    text-align: center;
    padding: 0 40px;
    font-size: 16px;
    cursor: pointer;
    transition: .3s;
    color: #222;
    border-radius: 20px;
    background: #F7F7F7;
    margin-right: 15px;
}

.codics-aonaer-info-sys-list-year-tab-item:hover {
    background: #ea5b18 !important;
    color: #FFF !important;
}

.codics-aonaer-info-sys-list-view {
    height: fit-content;
    width: 100%;

    position: relative;
    float: left;
    box-sizing: border-box;
    padding-left: 160px;
}

.codics-aonaer-info-sys-list-table-box {
    height: fit-content;
    width: 100%;
    position: relative;
    min-height: 100vh;
    float: left;
    border: 1px solid #EEE;
    background: #F7F7F7;
    box-sizing: border-box;
    padding: 30px;
    z-index: 2;
}

.codics-aonaer-info-sys-list-table-tab-item {
    height: 40px;
    width: 161px;
    position: absolute;
    margin: auto;
    z-index: 1;
    left: 0;
    line-height: 40px;
    text-align: center;
    box-sizing: border-box;
    border: 1px solid #EEE;
    background: #FFF;
    color: #222;
    font-size: 15px;
    cursor: pointer;
    user-select: none;
    -webkit-user-drag: none;
}

.codics-aonaer-info-sys-list-mingxi-table table {
    width: 100% !important;
}
</style>